import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter as _filter } from 'lodash';
import { first, tap } from 'rxjs';

import { Policy, PolicyAnalytics, PolicyDetails, PropertyPolicy } from '@amfam/policy/models';
import { AnalyticsFacade } from '@amfam/shared/analytics';
import { ClaimsNavigationPaths, PolicyChangeRequestType } from '@amfam/shared/models';
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';
import { ImpersonateRolesService, ImpersonationRoles } from '@amfam/shared/utility/impersonation';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { CopyService, ScrollService } from '@amfam/shared/utility/shared-services';

@Component({
  selector: 'property-risk-card',
  templateUrl: './property-risk-card.component.html',
  styleUrls: ['../policy-risk-card.scss'],
  standalone: false
})
export class PropertyRiskCardComponent {
  public policy: PropertyPolicy;
  public thirdPartyInterest = [];
  public editLenderBtnName: string;
  tpiEnabled = false;
  tpiRequestChangeEnabled = false;
  @Input() newTemplate = false;
  isFnolAuthorized$ = this.impersonateRolesService.isAuthorized(
    ImpersonationRoles.REPORT_CLAIM_VIEW
  );
  @Input() showDocuments = true;
  @Input() linkAddressChange = false;
  addressChangeState: any = { changeRequestType: PolicyChangeRequestType.ADDRESS_CHANGE };

  constructor(
    private featureFlagService: FeatureFlagService,
    private copyService: CopyService,
    private router: Router,
    private analyticsFacade: AnalyticsFacade,
    private scrollService: ScrollService,
    private store: Store,
    private impersonateRolesService: ImpersonateRolesService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.editLenderBtnName = this.copyService.getCopy(
      'policy.thirdPartyInterest.editLender.buttonName'
    );
  }

  onPolicyChange(policy: Policy) {
    this.tpiEnabled = this.featureFlagService.isEnabled('tpi_paid_by');
    this.tpiRequestChangeEnabled = this.featureFlagService.isEnabled('tpi_request_change');
    this.policy = <PropertyPolicy>policy;

    if (this.policy) {
      const thirdParty = _filter(this.policy.dwellingRoles, { roleType: 'ThirdPartyInterest' });
      if (thirdParty) {
        this.thirdPartyInterest = thirdParty;
      }
    }
  }

  OnEditLender() {
    this.analyticsFacade.trackButtonClick(PolicyAnalytics.buttonPoliciesEditLenderInfo);
    this.router.navigateByUrl(`/policies/changerequest`, {
      state: {
        changeRequestType: PolicyChangeRequestType.MORTGAGE_LENDER_DETAILS_CHANGE,
        selectedPolicyNumber: this.policy.policyNumber
      }
    });
  }

  onDocumentsClicked() {
    this.analyticsFacade.trackButtonClick(PolicyDetails.jumpLinkDocuments);
    const isSmallScreen = this.breakpointObserver.isMatched(
      '(max-width: 480px) and (orientation: portrait)'
    );
    if (isSmallScreen) this.scrollService.scrollToElement('documentsCard', 85);
    else this.scrollService.scrollToElement('documentsCard', 205);
  }

  fileAClaim() {
    this.store
      .select(BrandSelectors.selectIsPartner)
      .pipe(
        first(),
        tap(isPartner => {
          // Check FNOL feature is enabled.
          const claimsFNOLEnabled = this.featureFlagService.isEnabled('fnol') && !isPartner;

          if (claimsFNOLEnabled) {
            this.store.dispatch(
              fromRouterActions.Go({
                path: [ClaimsNavigationPaths.CLAIM_REPORTFNOL_HOME_PATH]
              })
            );
          } else {
            this.store.dispatch(
              fromRouterActions.Go({
                path: [ClaimsNavigationPaths.CLAIM_REPORT_HOME_PATH]
              })
            );
          }
        })
      )
      .subscribe();
  }

  requestPolicyChange() {
    this.analyticsFacade.trackButtonClick(PolicyDetails.buttonRequestPolicyChange);
    this.router.navigate(['/policies/changerequest'], {
      state: { changeRequestType: PolicyChangeRequestType.POLICY_COVERAGE_CHANGE }
    });
  }
}
